import React from 'react';
import { Crosshair, Timer, BrainCircuit } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#0D0D1A] relative overflow-hidden" data-id="element-129">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gaming-cyan/10 blur-[150px] rounded-full pointer-events-none" data-id="element-130" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-131">
        <div className="text-center mb-16" data-id="element-132">
          <div className="inline-flex items-center space-x-2 bg-gaming-bg border border-gaming-cyan/30 px-4 py-2 rounded-full mb-6 box-glow-cyan" data-id="element-133">
            <BrainCircuit className="w-4 h-4 text-gaming-cyan" data-id="element-134" />
            <span className="text-sm font-medium text-gaming-cyan uppercase tracking-wider" data-id="element-135">
              El Secreto del Crecimiento
            </span>
          </div>
          <h2 className="font-orbitron text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-136">
            Presentamos la <br className="hidden md:block" data-id="element-137" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gaming-cyan to-gaming-purple-light text-glow-cyan" data-id="element-138">
              Ingeniería de la Retención Implacable
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-139">
            A diferencia de otros cursos que te enseñan a configurar un
            software, este sistema se enfoca en la psicología del espectador.
          </p>
        </div>

        <div className="bg-gaming-bg border border-gaming-cyan/20 rounded-2xl p-8 md:p-12 box-glow-cyan" data-id="element-140">
          <div className="flex flex-col md:flex-row items-center gap-10" data-id="element-141">
            <div className="flex-shrink-0 relative" data-id="element-142">
              <div className="w-32 h-32 rounded-full border-4 border-gaming-cyan flex items-center justify-center bg-gaming-card relative z-10" data-id="element-143">
                <Timer className="w-16 h-16 text-gaming-cyan" data-id="element-144" />
              </div>
              <div className="absolute inset-0 bg-gaming-cyan/20 blur-xl rounded-full animate-pulse" data-id="element-145" />
            </div>

            <div data-id="element-146">
              <h3 className="font-orbitron text-2xl font-bold text-white mb-4 flex items-center" data-id="element-147">
                <Crosshair className="w-6 h-6 text-gaming-purple-light mr-3" data-id="element-148" />
                La "Regla de los 3 Minutos"
              </h3>
              <p className="text-gray-300 leading-relaxed text-lg mb-4" data-id="element-149">
                Es una metodología probada para capturar al espectador que entra
                por accidente y obligarlo psicológicamente a quedarse,
                participar y suscribirse.
              </p>
              <p className="text-gray-400 leading-relaxed" data-id="element-150">
                Siguiendo un protocolo de comunicación activa, transformarás a
                los "lurkers" (espectadores silenciosos) en una comunidad leal
                que interactúa en cada stream.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}